export default function ErrorImg({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="157"
        height="158"
        viewBox="0 0 157 158"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-auto"
      >
        <path
          d="M9.59444 158C8.31882 158 7.04319 157.751 5.82208 157.23C2.27868 155.722 0 152.283 0 148.454L0 38.9947C0 25.2065 11.2626 14.0002 25.12 14.0002L131.88 14.0002C145.727 14.0002 157 25.2065 157 38.9947V106.167C157 119.944 145.727 131.162 131.88 131.162H41.6377L16.2233 155.342C14.4026 157.078 12.0149 157.989 9.59444 157.989V158Z"
          fill="#FF5E26"
        />
        <path
          d="M49.482 89.8582L47.2799 77.644L57.7734 69.0238L44.9241 64.5768L42.7158 52.3285L64.2606 60.4566L66.8071 74.5814L49.482 89.8582ZM76.9648 104.701L75.5377 96.7855L97.7826 92.775L99.2097 100.69L76.9648 104.701ZM119.779 77.1845L98.2092 68.92L95.6627 54.7951L113.012 39.6548L115.221 51.9031L104.733 60.5575L117.576 64.9703L119.779 77.1845Z"
          fill="#F5F0E8"
        />
      </svg>
    </div>
  );
}
